import React, { useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";

// icons
import { Search, Plus, Trash2, FileEdit } from "lucide-react";
import { Link } from "react-router-dom";
import TableContainer from "Common/TableContainer";
import DeleteModal from "Common/DeleteModal";

// react-redux
import { useDispatch } from "react-redux";

import { ToastContainer } from "react-toastify";
import usePrices from "./hooks/usePrices";
import { getDiamondPrices as onGetDiamondPrices } from "slices/thunk";
import AddPricesModel from "./AddPricesModel";

const Prices = () => {
  const [show, setShow] = useState<boolean>(false);

  const dispatch = useDispatch<any>();

  const {
    data,
    setData,
    deleteModal,
    deleteToggle,
    handleDelete,
    filterSearchData,
    toggle,
    handleUpdateDataClick,
    onClickDelete,
    prices,
  } = usePrices({ show, setShow });

  // Get Data
  useEffect(() => {
    dispatch(onGetDiamondPrices());
  }, [dispatch]);

  useEffect(() => {
    setData(prices);
  }, [prices]);

  // columns

  const columns = useMemo(
    () => [
      // {
      //   header: (
      //     <div className="flex items-center h-full">
      //       <input
      //         id="CheckboxAll"
      //         className="size-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800"
      //         type="checkbox"
      //       />
      //     </div>
      //   ),
      //   enableSorting: false,
      //   id: "checkAll",
      //   cell: (cell: any) => {
      //     return (
      //       <div className="flex items-center h-full">
      //         <input
      //           id={"Checkbox" + cell.row.original.id}
      //           className="size-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800"
      //           type="checkbox"
      //         />
      //       </div>
      //     );
      //   },
      // },
      {
        header: "Id",
        accessorKey: "_id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <>
            <Link
              to="#!"
              className="transition-all duration-150 ease-linear order_id text-custom-500 hover:text-custom-600"
            >
              {cell.getValue()}
            </Link>
          </>
        ),
      },
      {
        header: "From",
        accessorKey: "caratsFrom",
        enableColumnFilter: false,
        enableSorting: false,
        // cell: (cell: any) => (
        //   <>
        //     <Link
        //       to="#!"
        //       className="transition-all duration-150 ease-linear order_id text-custom-500 hover:text-custom-600"
        //     >
        //       {cell.getValue()}
        //     </Link>
        //   </>
        // ),
      },
      {
        header: "To",
        accessorKey: "caratsTo",
        enableColumnFilter: false,
      },
      {
        header: "Color",
        accessorKey: "color",
        enableColumnFilter: false,
      },
      {
        header: "Clarity",
        accessorKey: "clarity",
        enableColumnFilter: false,
      },
      {
        header: "Round Price",
        accessorKey: "prices.round",
        enableColumnFilter: false,
      },
      {
        header: "Fancy Price",
        accessorKey: "prices.fancy",
        enableColumnFilter: false,
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex items-center justify-center gap-2">
            <a
              href="#!"
              className="flex items-center justify-center size-8 transition-all duration-150 ease-linear rounded-md bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500"
              onClick={() => {
                const data = cell.row.original;
                // handleUpdateDataClick(data);
              }}
            >
              <FileEdit className="size-3"></FileEdit>
            </a>

            <a
              href="#!"
              className="flex items-center justify-center size-8 transition-all duration-150 ease-linear rounded-md bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500"
              onClick={() => {
                const data = cell.row.original;
                // onClickDelete(data);
              }}
            >
              <Trash2 className="size-3"></Trash2>
            </a>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Prices" pageTitle="Diamonds" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <AddPricesModel show={show} setShow={setShow} />
      <ToastContainer closeButton={false} limit={1} />

      <div className="card" id="ordersTable">
        <div className="card-body">
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
            <div className="lg:col-span-3">
              <div className="relative">
                <input
                  type="text"
                  className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Search for ..."
                  autoComplete="off"
                  onChange={(e) => filterSearchData(e)}
                />
                <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
              </div>
            </div>
            <div className="lg:col-span-2 lg:col-start-11">
              <div className="ltr:lg:text-right rtl:lg:text-left">
                <Link
                  to="#!"
                  data-modal-target="addOrderModal"
                  type="button"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  onClick={toggle}
                >
                  <Plus className="inline-block size-4" />{" "}
                  <span className="align-middle">Add Price</span>
                </Link>
              </div>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns || []}
              data={data || []}
              customPageSize={10}
              divclassName="mt-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-center rtl:text-center bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 font-semibold text-slate-500 border-b border-slate-200 dark:border-zink-500 dark:text-zink-200 text-center"
              tdclassName="px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500 text-center"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
          ) : (
            <div className="noresult">
              <div className="py-6 text-center">
                <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                <p className="mb-0 text-slate-500 dark:text-zink-200">
                  We've searched more than 299+ orders We did not find any
                  orders for you search.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Prices;
